import React from 'react';
import { components } from 'react-select';
export var NoOptionsMessage = function NoOptionsMessage(props) {
  return /*#__PURE__*/React.createElement(components.NoOptionsMessage, props, /*#__PURE__*/React.createElement("span", {
    id: "no-options",
    role: "alert"
  }, props.children || "No options"));
};